export const BOOKING_URL = 'https://clients.mindbodyonline.com/classic/ws?studioid=598760&stype=-9'